export default __webpack_public_path__ + "static/media/wave.5d199f61.png";